import { useQuery } from '@tanstack/react-query'
import { getFeatureFlags } from 'api/factor'
import { qkGetFeatureFlags } from 'constants/QueryKeys/factor'

const useFeatureFlag = () => {
  const { data: featureFlagsResponse } = useQuery({
    queryKey: qkGetFeatureFlags(),
    queryFn: () => {
      return getFeatureFlags()
    },
  })

  return {
    enableCreditCheck: featureFlagsResponse?.creditCheck.enabled || false,
  }
}

export default useFeatureFlag
